PegasusTemplate.SocialShareEditController = Ember.ObjectController.extend();
